// extracted by mini-css-extract-plugin
export default {"shortcut":"Shortcut_shortcut__6OfYf","top":"Shortcut_top__H8DJ6","center":"Shortcut_center__JMaMd","bottom":"Shortcut_bottom__YwTOV"};